import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from "@angular/router";

@Injectable({
    providedIn: "root"
})
export class AuthGuard implements CanActivate {
    constructor(private readonly router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        if (localStorage.getItem("pf_token")) return true;

        return this.router.createUrlTree(["/account/login"], {queryParams: {returnUrl: state.url}});
    }
}
